import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  /**
   * Вызывается при перехвате ошибки рендера. КРИТИЧНО: для эксклюзивных
   * эффектов (custom_effects) это единственный способ разблокировать очередь —
   * без onError exclusiveMode застрянет навсегда (см. план §8).
   */
  onError: () => void
  children: ReactNode
}

interface State {
  hasError: boolean
}

/**
 * Локальный ErrorBoundary для оверлей-эффектов. Ловит ошибку рендера одного
 * эффекта, рендерит null (ничего) и дёргает onError, чтобы очередь поехала дальше.
 */
export class EffectErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.warn('[overlay] effect render error:', error, info.componentStack)
    this.props.onError()
  }

  render(): ReactNode {
    if (this.state.hasError) return null
    return this.props.children
  }
}
